import { render, staticRenderFns } from "./ParamTipoProprietario.vue?vue&type=template&id=46253ec9"
import script from "./ParamTipoProprietario.vue?vue&type=script&lang=js"
export * from "./ParamTipoProprietario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports